import React from 'react';
import { render } from 'react-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { datadogRum } from '@datadog/browser-rum';
import { App } from './app/App';
import { getDefaultLanguage } from './utils/utils';
import './index.scss';
import { datadogLogs } from '@datadog/browser-logs';

function loadGoogleMapsApiScript(key: string) {
  let script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&language=${getDefaultLanguage()}&libraries=places,drawing`;
  script.async = true;

  document.head.appendChild(script);
}

(async () => {
  try {
    const response = await fetch('/api/configs');
    const configs: any = await response.json();

    window.tz_globalConfigs = configs;

    loadGoogleMapsApiScript(configs?.googleMapsApiKey);

    const LaunchDarklyProvider = await asyncWithLDProvider({
      clientSideID: configs?.launchDarklyId,
      user: {
        key: 'CLIENT_PORTAL_USER',
      },
      options: {
        streaming: false,
      },
    });

    const { ddApplicationId, ddClientToken, ddSite } = window.tz_globalConfigs;

    if (ddApplicationId && ddClientToken && ddSite) {
      datadogRum.init({
        applicationId: window.tz_globalConfigs.ddApplicationId,
        clientToken: window.tz_globalConfigs.ddClientToken,
        site: 'datadoghq.eu',
        service: 'client-portal',
        env: window.tz_globalConfigs.environment,
        allowedTracingUrls: [/https:\/\/.*\.transferz\.com/, /https:\/\/.*\.taxi2airport\.com/],
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackInteractions: true,
        trackFrustrations: true,
        defaultPrivacyLevel: 'mask-user-input',
      } as any);

      datadogLogs.init({
        clientToken: window.tz_globalConfigs.ddClientToken,
        site: 'datadoghq.eu',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        service: 'client-portal',
        env: window.tz_globalConfigs.environment,
        forwardConsoleLogs: 'all',
      });
    }

    render(
      <LaunchDarklyProvider>
        <App />
      </LaunchDarklyProvider>,
      document.getElementById('root'),
    );
  } catch (e) {
    render(
      <div>An error occured while fetching environment configs.</div>,
      document.getElementById('root'),
    );
  }
})();
